import { DataTableColumnVariant, DataTableVariant, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { TranslateService } from '@ngx-translate/core';

interface IGetUserRoleDataTableStructureProps {
  translate: TranslateService;
  userRoles: string[];
  onDetach: (code: any, type: 'role' | 'ac' | 'com') => void;
}

export const getUserRoleDataTableStructure = ({ translate, userRoles, onDetach }: IGetUserRoleDataTableStructureProps): DynamicDataTable => {
  return {
    singular: 'settings.userInfo.table.role',
    plural: 'settings.userInfo.table.roles',
    columns: [{ label: 'settings.userInfo.table.role', accessorKey: 'role', variant: DataTableColumnVariant.TEXT }],
    variant: DataTableVariant.COMMON,
    sizes: [10],
    stripedRows: true,
    searchableFields: ['role'],
    rowActionsFn: (row: any) => {
      const isLastRole = userRoles && userRoles.length === 1;
      return {
        additionalActions: {
          Actions: [
            {
              label: translate.instant('settings.userInfo.tabs.deleteRole'),
              icon: 'pi pi-trash',
              action: () => {
                onDetach(row.name, 'role');
              },
              disabled: isLastRole,
            },
          ],
        },
      };
    },
  };
};
